export default {
  color: {
    primary: '#0000ff',
    danger: '#ff3860',
    success: '#23d160',
    text: 'hsl(0, 0%, 21%)'
  },
  font: {
    family: '"Open Sans", sans-serif',
    size: 16
  },
  breakpoints: {
    xs: '@media (min-width: 576px)',
    sm: '@media (min-width: 768px)',
    md: '@media (min-width: 992px)',
    lg: '@media (min-width: 1200px)',
    xl: '@media (min-width: 1440px)'
  },
  containers: {
    xs: 540,
    sm: 720,
    md: 960,
    lg: 1140,
    xl: 1280
  },
  layout: {
    gutter: 20,
    gap: 30,
    headerHeight: 70
  }
};



// WEBPACK FOOTER //
// ./src/assets/styles/Theme.js